export default "__VITE_ASSET__D6hl6esG__"